import { render, staticRenderFns } from "./ClaimsSupport.vue?vue&type=template&id=789f318b&lang=html"
import script from "./ClaimsSupport.vue?vue&type=script&lang=js"
export * from "./ClaimsSupport.vue?vue&type=script&lang=js"
import style0 from "./ClaimsSupport.vue?vue&type=style&index=0&id=789f318b&prod&lang=stylus&module=attr"




function injectStyles (context) {
  
  this["attr"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderTemplate: require('/var/www/malayan/web/components/global/templates/HeaderTemplate.vue').default,CardDeckTemplate: require('/var/www/malayan/web/components/global/templates/CardDeckTemplate.vue').default})
